import { VectorIconWrapper } from '@/containers/SearchFlightTab';
import { LocationSearchType } from '@/containers/SearchFlightTab/SearchDialog/index.d';
import SearchFormInput from '@/containers/SearchFlightTab/SearchFormInput';
import { addAllHomePoints } from '@/slices/area/slices/searchFlightFormSlice';
import { style } from '@/styles/globals';
import { useAppSelector } from '@/utils/hook';
import { IconButton } from '@mui/material';
import { VectorIcon } from 'public/icons';
import React from 'react';
import { useDispatch } from 'react-redux';

function SearchInput() {
  const dispatch = useDispatch();
  const {
    startPointHome: startPoint, toPointHome: toPoint,
  } = useAppSelector((state) => state.searchFlightForm);

  return (
    <div style={{ position: 'relative' }}>
      <SearchFormInput
        type={LocationSearchType.FROM}
      />
      <SearchFormInput
        type={LocationSearchType.TO}
      />
      <VectorIconWrapper>
        <IconButton
          onClick={() => {
            dispatch(addAllHomePoints([
              {
                data: startPoint,
                type: 'to',
              }, {
                data: toPoint,
                type: 'from',
              },
            ]));
          }}
          style={{
            width: 40,
            height: 40,
          }}
        >
          <VectorIcon color={style.color.black4} />
        </IconButton>
      </VectorIconWrapper>
    </div>
  );
}

export default React.memo(SearchInput);
